import { mergeStyleSets } from '@uifabric/merge-styles';
import theme, { layout } from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  root: {
    backgroundColor: theme.palette.neutralWhite,
    flex: 1,
    height: '100%',
    width: '100%',
    margin: '0 auto',
    position: 'relative',
    padding: `${pxToRem(24)} 1rem ${pxToRem(24)}`,
    selectors: {
      [layout.breakpoints.min.md]: {
        maxWidth: `calc(${pxToRem(910)} + 4rem)`,
        padding: `${pxToRem(40)} 1rem ${pxToRem(28)}`,
      },
      [layout.breakpoints.min.lg]: {
        maxWidth: `calc(${pxToRem(910)} + 4rem)`,
        paddingLeft: '2rem',
        paddingRight: '2rem',
      },
      [layout.breakpoints.min.xxl]: {
        maxWidth: `calc(${pxToRem(1074)} + 4rem)`,
      },
    },
  },
  bg: {
    backgroundColor: theme.palette.neutralWhite,
    borderBottom: `${theme.palette.themePrimary} solid ${pxToRem(4)}`,
  },
});
